// extracted by mini-css-extract-plugin
export default {"box":"detail_box__A8tCq","subTitle":"detail_subTitle__N3Eyc","flexBox":"detail_flexBox__7ctXW","fix":"detail_fix__sOJgW"};